import { Text, View } from 'react-native'

import { BaseModalConfig } from '../'
import { BottomModalButton } from '../../../BottomModalContent/BottomModalButton'
import { ConfirmOption } from '../../../BottomModalContent/Content'
import { GameModal } from '@/screens/GameContainer/Modals/GameModalContainer'
import { translate } from '../../../../../i18n'
import { styles } from './EndPracticeGame.style'

export interface EndPracticeGameProps extends BaseModalConfig {
  visible?: boolean
  confirm: ConfirmOption
  cancel: ConfirmOption
}

export const EndPracticeGame = ({ visible, onClose, confirm, cancel }: EndPracticeGameProps) => {
  const content = (
    <View style={styles.modalContainer}>
      <View style={styles.container}>
        <Text style={styles.titleStyle}>{translate('gameScreen.endPracticeGame.title')}</Text>
        <Text style={styles.subTitleStyle}>{translate('gameScreen.endPracticeGame.subtitle')}</Text>
        <BottomModalButton
          text={confirm.text}
          onPress={confirm.onPress}
          size="large"
          alternateFont
          textStyle={[styles.buttonTitleStyle]}
        />
        <BottomModalButton
          text={cancel.text}
          onPress={cancel.onPress}
          size="large"
          alternateFont
          alternateColor
          textStyle={[styles.buttonTitleStyle]}
        />
      </View>
    </View>
  )

  if (visible != null) {
    return (
      <GameModal visible={visible} onClose={onClose}>
        {content}
      </GameModal>
    )
  }

  return content
}
